/* eslint-disable no-magic-numbers */
/* eslint-disable @typescript-eslint/no-empty-function */
/* eslint-disable no-nested-ternary */
/* eslint-disable no-useless-return */
/* eslint-disable max-depth */
/* eslint-disable prefer-template */
/* eslint-disable no-return-assign */
/* eslint-disable prefer-const */
/* eslint-disable max-lines */
/* eslint-disable @typescript-eslint/prefer-for-of */
/* eslint-disable max-lines-per-function */
/* eslint-disable @typescript-eslint/no-floating-promises */
/* eslint-disable no-unused-expressions */
/* eslint-disable complexity */
/* eslint-disable @typescript-eslint/prefer-optional-chain */
/* eslint-disable no-var */
/* eslint-disable eqeqeq */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable max-params */
/* eslint-disable @typescript-eslint/array-type */
/* eslint-disable @typescript-eslint/member-ordering */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/explicit-member-accessibility */

import { Component, ElementRef, EventEmitter, HostListener, Input, OnInit, Output, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-chat-flyout',
    templateUrl: './chat-flyout.component.html',
    styleUrls: ['./chat-flyout.component.scss'],
    standalone: false
})
export class ChatFlyoutComponent implements OnInit {
    @Input() isOpen = false;
    @Input() headerText = '';
    @Input() hideHistoryPanel = false;
    @Output() isOpenChange = new EventEmitter<boolean>();
    @Output() onRightPanelToggle = new EventEmitter<boolean>();

    @ViewChild('flyout') flyoutElement: ElementRef;
    @ViewChild('resizeHandle') resizeHandle: ElementRef;

    private initialWidth: number;
    private isDragging = false;
    private screenWidth: number;
    private defaultWidth = 33.33; // 1/3 of the screen width (in %)
    private maxWidth = 80; // 2/3 of the screen width (in %)
    public currentWidth = this.defaultWidth;

    // Split panel properties
    public showRightPanel = false;
    public leftPanelWidth = 100; // as percentage of flyout width
    public rightPanelWidth = 0; // as percentage of flyout width
    public splitThreshold = 50; // percentage of screen width when split activates

    constructor(private elementRef: ElementRef, public translate: TranslateService) { }

    ngOnInit(): void {
        this.updateScreenWidth();
        this.updatePanelSizes();
    }

    @HostListener('window:resize', ['$event'])
    onResize(event) {
        this.updateScreenWidth();
        this.updatePanelSizes();
    }

    private updateScreenWidth(): void {
        this.screenWidth = window.innerWidth;
    }

    /**
     * Updates the panel sizes based on the current flyout width
     * - If flyout width > splitThreshold, show both panels (60/40 split)
     * - Otherwise, show only left panel (100% width)
     */
    private updatePanelSizes(): void {
        const shouldShowRightPanel = !this.hideHistoryPanel && this.currentWidth > this.splitThreshold;

        if (shouldShowRightPanel && !this.showRightPanel) {
            this.showRightPanel = true;
            this.leftPanelWidth = 70;
            this.rightPanelWidth = 30;
        } else if (!shouldShowRightPanel && this.showRightPanel && !this.isRightPanelManuallyToggled) {
            this.showRightPanel = false;
            this.leftPanelWidth = 100;
            this.rightPanelWidth = 0;
        }
    }

    // Flag to track if the right panel was manually toggled
    private isRightPanelManuallyToggled = false;

    /**
     * Toggles the visibility of the right panel manually
     */
    toggleRightPanel(): void {
        this.isRightPanelManuallyToggled = true;
        this.showRightPanel = !this.showRightPanel;

        if (this.showRightPanel) {
            this.leftPanelWidth = this.currentWidth < this.defaultWidth ? 0 : 70;
            this.rightPanelWidth = this.currentWidth < this.defaultWidth ? 100 : 30;

            // If flyout is too narrow, increase it to accommodate both panels
            if (this.currentWidth < this.splitThreshold) {
                this.currentWidth = this.splitThreshold + 5; // Add 5% to be safe
            }
        } else {
            this.leftPanelWidth = 100;
            this.rightPanelWidth = 0;
        }

        // Reset the manual toggle flag after a delay
        setTimeout(() => {
            this.isRightPanelManuallyToggled = false;
            this.onRightPanelToggle.emit(this.showRightPanel);
        }, 500);
    }

    toggleFlyout(): void {
        this.isOpen = !this.isOpen;
        this.isOpenChange.emit(this.isOpen);

        if (this.isOpen) {
            // Reset to default width when opening
            this.currentWidth = this.defaultWidth;
            // Reset panel states
            this.showRightPanel = false;
            this.leftPanelWidth = 100;
            this.rightPanelWidth = 0;
            this.isRightPanelManuallyToggled = false;
        }
    }

    startResize(event: MouseEvent): void {
        event.preventDefault();
        this.isDragging = true;
        this.initialWidth = this.flyoutElement.nativeElement.offsetWidth;

        // Add mousemove and mouseup event listeners
        document.addEventListener('mousemove', this.resizeMouseMove);
        document.addEventListener('mouseup', this.resizeMouseUp);
    }

    @HostListener('document:mousemove', ['$event'])
    resizeMouseMove = (event: MouseEvent) => {
        if (this.isDragging) {
            const newWidth = 100 - ((event.clientX / this.screenWidth) * 100);

            // Ensure width is within constraints
            if (newWidth >= this.defaultWidth && newWidth <= this.maxWidth) {
                this.currentWidth = newWidth;
                this.updatePanelSizes();
            }
        }
    }

    @HostListener('document:mouseup')
    resizeMouseUp = () => {
        this.isDragging = false;

        // Remove event listeners
        document.removeEventListener('mousemove', this.resizeMouseMove);
        document.removeEventListener('mouseup', this.resizeMouseUp);
    }

    closeFlyout(): void {
        this.isOpen = false;
        this.isOpenChange.emit(this.isOpen);
        // Reset panel states
        this.showRightPanel = false;
        this.leftPanelWidth = 100;
        this.rightPanelWidth = 0;
        this.isRightPanelManuallyToggled = false;
    }
}